exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".summary-container[data-v-6e7c73d2]{display:none!important;float:unset!important}@media (min-width:1280px){.summary-container[data-v-6e7c73d2]{display:flex!important}}", ""]);

// exports
